import moment from 'moment'

export const GlobalMixins = {
  data () {
    return {
      globalItemsPerPage: 50,
      globalFooterOptions: {
        'items-per-page-options': [10, 50, 100, 200, -1]
      }
    }
  },

  methods: {
    formatDateTime: function (time) {
      if (time) {
        return moment(time).format('YYYY-MM-DD hh:mm a')
      }
      return 'N/A'
    },

    translateAction: function (value) {
      if (value === 'actionSiteInvite') {
        return 'Site Invitation'
      }
      if (value === 'actionEventInvite') {
        return 'Event Invitation'
      }
      if (value === 'actionGroupInvite') {
        return 'Group Invitation'
      }
      if (value === 'actionEventJoin') {
        return 'Event Join Request'
      }
      if (value === 'actionGroupJoin') {
        return 'Group Join Request'
      }
      if (value === 'actionSiteJoin') {
        return 'Site Join Request'
      }
      return 'N/A'
    }
  }
}

export const AuthMixins = {
  data () {
    return {
      roles: [
        {
          name: 'Guest',
          value: 'roleGuest'
        },
        {
          name: 'Member',
          value: 'roleMember'
        },
        {
          name: 'Leader',
          value: 'roleLeader'
        },
        {
          name: 'Admin',
          value: 'roleAdmin'
        }
      ]
    }
  },

  methods: {
    userRoleGet: function (memberships, resource) {
      if (memberships) {
        var r = memberships.sites.find(o => o.resource === resource)
        if (r) {
          return r
        }
      }
      return {}
    },

    userRoleDisplay: function (memberships, resource) {
      var r = this.userRoleGet(memberships, resource)
      if (r.role) {
        return this.displayRole(r.role)
      }

      return 'N/A'
    },

    displayRole: function (role) {
      if (role === 'roleMember') {
        return 'Member'
      } else if (role === 'roleLeader') {
        return 'Leader'
      } else if (role === 'roleAdmin') {
        return 'Administrator'
      }
      return 'N/A'
    }
  }
}
